import AsyncStorage from '@react-native-async-storage/async-storage';

const KEY_PREFIX = 'end_walk_draft_';

export async function saveEndWalkDraft(draft: any, id?: string): Promise<string> {
  const draftId = id || `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  await AsyncStorage.setItem(`${KEY_PREFIX}${draftId}`, JSON.stringify(draft));
  return draftId;
}

export async function loadEndWalkDraft(id: string): Promise<any | null> {
  try {
    const raw = await AsyncStorage.getItem(`${KEY_PREFIX}${id}`);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.warn('Failed to load end-walk draft', id, err);
    return null;
  }
}

export async function clearEndWalkDraft(id?: string): Promise<void> {
  if (id) {
    await AsyncStorage.removeItem(`${KEY_PREFIX}${id}`);
    return;
  }
  // Clear all stale drafts (e.g. on save/cancel)
  try {
    const keys = await AsyncStorage.getAllKeys();
    const stale = keys.filter((k) => k.startsWith(KEY_PREFIX));
    if (stale.length > 0) await AsyncStorage.multiRemove(stale);
  } catch (err) {
    console.warn('Failed to clear end-walk drafts', err);
  }
}
